import "@shared/assets/styles/common.css"
import "@shared/assets/styles/common.custom.css"

import React from "react"

import { MetaData } from "@shared/components"
import {
  LayerPopupProvider,
  ScheduleProvider, useAccount,
  useSchedule,
} from "@shared/contexts"
import {
  useCriteo,
  useCRM,
  useInstallChromePopup,
  useWatchingSchedule,
} from "@shared/hooks"
import {getParam, isWeekend, isWindow7, toYYYYMMDD} from "@shared/modules"

import classNames from "classnames"
import {
  Footer,
  LivePlayer,
  QuickMenu,
  RandomPopup,
  Sidebar,
  VideojsPlayer,
  WowMoney,
} from "live/components"
import { EventPopup } from "live/components/eventPopup"
import {
  RefreshPlayerProvider,
  SidebarEnabledProvider,
  useIsSidebarEnabled,
  usePlayerRefreshIsRemounted,
  WowMoneyProvider,
} from "live/contexts"
import { useCheckOnline, usePreviewPopup } from "live/hooks"

import { MiniPlayerEnabledProvider } from "../live/contexts/miniPlayer"
import {ChartRefProvider} from "../chart/context";

function LivePage() {
  const { schedule } = useSchedule()
  const { account } = useAccount()
  const isRemountedRefreshingPlayer = usePlayerRefreshIsRemounted()
  const isSidebarEnabled = useIsSidebarEnabled()

  const isOnlyPlayerMode = getParam("is_only_player") === "true"
  const isHLSMode = getParam("player_type") === "hls"
  const isFlash = getParam("player_type") === "flash" || isWindow7
  const isScheduleEnd = schedule && schedule.scheduleEnd ? true : false
  const isFullMode = isOnlyPlayerMode || isScheduleEnd
  const isAnonymous = account.viewer?.role === "ANONYMOUS"

  useCriteo()
  useCRM({ disabled: isOnlyPlayerMode })
  useCheckOnline()
  useWatchingSchedule()
  useInstallChromePopup()

  const { isPreviewBlocked } = usePreviewPopup({ disabled: !isAnonymous })

  return (
    <>
      <MetaData />
      {isOnlyPlayerMode && isHLSMode ? (
        <VideojsPlayer />
      ) : (
        <div id="live">
          <section
            className={classNames("wrap", {
              paddingZero: isFullMode,
              paddingRightZero: !isSidebarEnabled,
            })}
          >
            {isRemountedRefreshingPlayer || isPreviewBlocked ? (
              <LivePlayer.FakePlayer />
            ) : (
              <LivePlayer isFlash={isFlash} isFullMode={isFullMode} />
            )}
            {!isFullMode && (
              <>
                <Footer />
                <Sidebar />
                <QuickMenu />
                <EventPopup />
                <WowMoney />
              </>
            )}
          </section>
        </div>
      )}
      {!isOnlyPlayerMode && <RandomPopup />}
    </>
  )
}

export default () => (
  <ScheduleProvider>
    <RefreshPlayerProvider>
      <LayerPopupProvider>
        <SidebarEnabledProvider>
          <MiniPlayerEnabledProvider>
            <ChartRefProvider>
              <WowMoneyProvider>
                <LivePage />
              </WowMoneyProvider>
            </ChartRefProvider>
          </MiniPlayerEnabledProvider>
        </SidebarEnabledProvider>
      </LayerPopupProvider>
    </RefreshPlayerProvider>
  </ScheduleProvider>
)
